import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component, Fragment } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import BindDevice from '../common/BindDevice';
import { bindActionCreators } from 'redux'
import classNames from 'classnames';
import { connect } from 'react-redux'
import { logout } from '../../modules/auth'
import { proxyBase } from '../../modules/config';
import { push } from 'connected-react-router'

const styles = (theme: Theme) => createStyles({
    root: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(2),
    },
  }
)

type State = {
}

class BindContainer extends Component<Props, State> {  
  render() {
    const { auth, bindings, classes, push, proxyBase } = this.props;

    if(!auth.authenticated) {
      return <Redirect to={proxyBase()} />
    }

    if(bindings.deviceBindingType === "HARD_BIND") {
      return <Redirect to={proxyBase("/pib/overview")} />
    }
    
    return (
      <Fragment>
        <div className={classNames(classes.root, 'maxWidth')}>
          <BindDevice complete={ () => push(proxyBase('/pib/overview')) } showSkip={true} />
        </div>
      </Fragment>
    )
  }
}



const mapStateToProps = ({auth, bindings, intl}: IStoreState) => ({
  auth,
  bindings,
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch)  =>
  bindActionCreators(
    {
      push,
      logout,
      proxyBase
    }, dispatch
  )

interface MatchParams {
    url: string;
}

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps<MatchParams> {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BindContainer));